// components/Filter.tsx
import React from 'react';
import { Box, Button, Grid } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const Filter = ({ children, onFilter, onFilterReset, rightAction }) => {
    const handleSubmit = (e) => {
        e.preventDefault();
        const form = new FormData(e.target);
        const filters = {};
        for (let [key, value] of form.entries()) {
            if (value) filters[key] = value;
        }
        onFilter(filters);
    };

    return (
        <form onSubmit={handleSubmit}>
            <Grid container spacing={2} alignItems="center">
                {children}
            </Grid>
            <Box mt={2} mb={2} display="flex" alignItems="center" justifyContent="space-between" gap={2}>
                <Box>
                    <Button type="submit" variant="contained" startIcon={<SearchIcon />}
                        sx={{
                            textTransform: 'none', 
                            backgroundColor: '#1976d2', 
                            color: 'white', 
                            borderRadius: '10px', 
                            fontWeight: 'bold'
                        }}>
                        Bilgi Getir
                    </Button>
                    <Button
                        type="button"
                        variant="outlined"
                        color="secondary"
                        onClick={onFilterReset}
                        sx={{
                            textTransform: 'none', 
                            color: '#1976d2', 
                            border: 'none',
                            fontWeight: '500',
                            marginLeft: '10px',
                            '&:hover': {
                                backgroundColor: '#e3f2fd' 
                            }
                        }}
                    >
                        Sıfırla
                    </Button>
                </Box>
                {rightAction && (
                    <Box>
                        {rightAction}
                    </Box>
                )}
            </Box>
        </form>
    );
};

export default Filter;
